import Button from "@app/components/button";
import GradientContainer from "@app/components/gradient/gradient-container";
import TextGradient from "@app/components/gradient/gradient-text";
import Image from "next/image";
import { useState } from "react";

const DesktopOfficeMixedUse = ({ inView6 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="flex flex-row -mb-[7px] ">
      <div className="">
        <div className="hidden xl:block">
          <Image
            src="/images/industries/office.png"
            alt="office"
            width={720}
            height={712}
          />
        </div>
        <div className="xl:hidden">
          <Image
            src="/images/industries/office.png"
            alt="office"
            width={520}
            height={512}
          />
        </div>
      </div>
      <div className=" bg-background-mid-em flex items-center justify-center xl:justify-start">
        <div
          className={`shadow-lg-light absolute bg-opacity-90 xl:-ml-96 2xl:-ml-40 bg-light 
          w-[80%] xl:w-[65%] 2xl:w-[50%] blur-content rounded-2xl p-6`}
          style={{
            visibility: inView6 ? "visible" : "hidden",
            transform: inView6 ? "translateX(0%)" : "translateX(10%)",
            transition: "transform 500ms ease-in",
          }}>
          <div
            className={`flex flex-col ml-2 space-y-5 
            ${
              isExpanded
                ? "h-[410px] xl:h-[545px] xl-2:!h-[505px] 2xl:!h-[545px]"
                : "h-[310px] xl:h-[385px] xl-2:!h-[365px] 2xl:!h-[385px] "
            } 
            transition-[height] ease-out duration-500`}>
            <TextGradient>
              <p className="h2">06</p>
            </TextGradient>
            <p className="h4 xl:h3 text-background-primary-dark">
              Office & Mixed Use
            </p>
            <div>
              <GradientContainer overrideClassName="w-[22%] h-2" />
            </div>
            <div className=" text-text-color-mid-em-light space-y-2 xl:space-y-5">
              <p>
                SimpleWaste represents offices and mixed-use building
                environments. Our unique service and technology platform are
                customized to accommodate single tenants or property management
                groups.
              </p>
              <p className="hidden xl:block">
                Through our technology platform, clients are able to secure cost
                reduction with ease-of-use vendor management across all 50
                states.
              </p>
              {isExpanded && (
                <div className="space-y-5">
                  <p className="xl:hidden">
                    Through our technology platform, clients are able to secure
                    cost reduction with ease-of-use vendor management across all
                    50 states.
                  </p>
                  <p>
                    Reduce your property refuse and utility costs through our
                    aggregate purchasing model.
                  </p>
                  <p className="hidden xl:block">
                    With the RFP Optimizer you&apos;ll be able to automate bids,
                    select preferred vendors, and manage services at a property
                    by property basis. Vendor updates and communication are
                    recorded and tracked within the technology platform, giving
                    your management team access to LIVE data with 100%
                    visibility.
                  </p>
                </div>
              )}
            </div>
            <div className="flex h-full items-end">
              <div>
                <Button onClick={() => setIsExpanded(!isExpanded)}>
                  {isExpanded ? "Read less" : "Read more"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopOfficeMixedUse;
